import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

// Renders a `LABEL value` pair beneath an option name, with the matched
// portion of the value highlighted. Sizes (10/12px) and weights (500/600) come
// from the material-typeahead design mockup. The match highlight uses the
// dedicated search-highlight token (theme.semantic.searchHighlightBg) so it
// keeps its pale-yellow prominence in light and adapts in dark mode.
export default function OptionCodePair({
  label,
  value,
  query,
}: {
  label: string;
  value: string;
  query: string;
}) {
  const theme = useTheme();
  const parts = parse(value, match(value, query, { insideWords: true }));

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'baseline', gap: 0.5 }}>
      <Typography
        component="span"
        sx={{
          fontSize: 10,
          fontWeight: 600,
          lineHeight: 1,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: theme.brandV2.colors.treadGray4,
        }}
      >
        {label}
      </Typography>
      <Typography
        component="span"
        sx={{ fontSize: 12, color: theme.brandV2.colors.treadGray2 }}
      >
        {parts.map((part, index) => (
          <span
            key={`${part.text}-${index}`}
            style={{
              fontWeight: part.highlight ? 700 : 'inherit',
              backgroundColor: part.highlight
                ? theme.semantic.searchHighlightBg
                : 'transparent',
              borderRadius: 2,
            }}
          >
            {part.text}
          </span>
        ))}
      </Typography>
    </Box>
  );
}
